import { Component } from 'react'
import PropTypes from 'prop-types'
import { Waypoint } from 'react-waypoint'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import actions from './actions.js'

class ScrollSpy extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    group: PropTypes.string.isRequired,
    topOffset: PropTypes.string
  }

  static defaultProps = {
    topOffset: '0px'
  }

  constructor(props) {
    super(props)
    this.onPositionChange = this.onPositionChange.bind(this)
  }

  onPositionChange({ event, waypointTop, currentPosition }) {
    this.props.setVisibility({
      name: this.props.name,
      group: this.props.group,
      visible: currentPosition === Waypoint.inside,
      top: waypointTop,
    })
  }

  render() {
    return (
      <Waypoint
        onPositionChange={this.onPositionChange}
        topOffset={this.props.topOffset}>
        {this.props.children}
      </Waypoint>
    )
  }
}

export default connect(
  () => ({}),
  (dispatch) => bindActionCreators(actions, dispatch)
)(ScrollSpy)